import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class JoinTypeService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetJoinType():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/JoinType/Get`);
  }

  DeleteJoinType(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/JoinType/Delete?id=${id}`);
  }

  CreateJoinType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinType/Create`,data);
  }
  UpdateJoinType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinType/Update`,data)
  }
}
